import(/* webpackMode: "eager" */ "/home/ubuntu/shoptrendz/src/app/error.tsx");
